import React from 'react';
import { connect } from 'react-redux';
import { FontIcon } from 'material-ui';
import RightIcon from './right-icon';
import R from 'ramda';
import { checkIfUpdatesExist } from '../../../../utils/mass-rate-change-helpers';

const submMenuMap = {
  nett: '      nett rates',
  commission: '      commissions',
  discount: '      discounts',
};

const menuMap = {
  RATES: 'seasonRates',
  'SPECIAL OFFERS': 'offers',
  EXTRA: 'extras',
};

const MenuItem = props => {
  const { name, subMenus, hasUnsavedChanges, onTouchTap, isActive, isUpdated, gettingData } = props;

  const getLabelColorFn = () => {
    if (hasUnsavedChanges) return '#ff4081';
    if (isActive) return '#00bcd4';
    return 'white';
  }
  if (!subMenus) {
    return (
      <div className={`contracting-left-nav-widget-link ${isActive ? 'is-active' : ''}`} style={{ margin: '0', lineHeight: '16px', padding: '7px', paddingLeft: '24px' }} onClick={onTouchTap}>
        <div style={{ fontSize: '12px', color: getLabelColorFn(), display: 'inline-block', whiteSpace: 'pre', textTransform: 'uppercase' }}>{submMenuMap[name.trim()] || name}</div>
        {isUpdated ? <FontIcon className="tc-icon-check" color="#00bcd4" style={{ marginLeft: '5px', fontSize: '16px' }}/> : <span></span>}
        <RightIcon subMenus={subMenus} gettingData={gettingData} />
      </div>
    );
  }
  return (
    <div style={{ textTransform: 'uppercase', paddingBottom: '5px' }}>
      <div style={{ color: 'white', display: 'inline-block', whiteSpace: 'pre', paddingLeft: '24px' }}>{name}</div>
      <RightIcon subMenus={subMenus} gettingData={gettingData} />
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
  offers: contracting.massRateChange.get('offers').toJS(),
  extras: contracting.massRateChange.get('extras').toJS(),
});

export default connect(mapStateToProps)(MenuItem);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/left-nav/nav-menu-item.jsx